const pushEcommerceTrackingEvent = function(eventName, data = {}) {
    if (window.dataLayer) {
        dataLayer.push({
            event: eventName,
            ecommerce: data,
        });
    }
};

export default pushEcommerceTrackingEvent;
